import { SalesActionsType } from 'api-hooks/general/model';
import { SaleModel } from 'api-hooks/sale/common';
import Popover from 'components/popover';
import useRevertDraftAction from 'hooks/use-revert-draft-action';
import useRevertVoidAction from 'hooks/use-revert-void-action';
import { ProductSaleFormType } from 'legacy-modules/product/sales/components/form-type';
import { TourSaleFormType } from 'legacy-modules/tour/tour-sale/components/form-type';

import { ActivitySaleFormType } from '../activity/components/form-type';
import { CruiseSaleFormType } from '../cruise/components/form-type';
import useSalesActions from '../hooks/use-sales-actions';
import useSalesEditAction from '../hooks/use-sales-edit-action';
import { HotelSaleFormType } from '../hotel/components/form-type';
import { TicketSaleFormType } from '../ticket-sale/components/form-type';
import { DocumentSaleFormType } from '../travel-document/components/form-type';

export interface SalesActionComponentProps {
  type: SalesActionsType;
  data: SaleModel;
  defaultValues:
    | HotelSaleFormType
    | DocumentSaleFormType
    | CruiseSaleFormType
    | TicketSaleFormType
    | ActivitySaleFormType
    | TourSaleFormType
    | ProductSaleFormType;
}

export default function SalesActionComponent(props: SalesActionComponentProps) {
  const { editAction } = useSalesEditAction(props.data, props.type);
  const {
    completeComponent,
    incompleteComponent,
    requestApprovalButton,
    resolverButton,
    ...rest
  } = useSalesActions({
    type: props.type,
    data: props.data,
    defaultValues: props.defaultValues,
  });

  const actions = [editAction, ...rest.actions].filter(
    (action) => action.isAllowed,
  );

  const { revertVoidButton } = useRevertVoidAction(props.type, props.data);
  const { revertDraftButton } = useRevertDraftAction(props.type, props.data);

  return (
    <div
      style={{
        display: 'flex',
        gap: 16,
      }}
    >
      {revertDraftButton}
      {requestApprovalButton}
      {resolverButton}
      {revertVoidButton}
      {incompleteComponent}
      {completeComponent}
      <Popover actions={actions} />
    </div>
  );
}
